import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { MarketButton, MarketEmptyState } from '@market/react';

import styles from 'typescript/apps/checkout_v3/components/order_summary/components/error_state.module.scss';

export const ORDER_SUMMARY_ERROR_TEST_ID = 'order-summary-error';

export const ErrorState = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const onClick = () => {
    history.go(0); // refresh page
  };

  return (
    <MarketEmptyState
      data-testid={ORDER_SUMMARY_ERROR_TEST_ID}
      className={styles.errorState}
    >
      <h3 slot="primary-text">{t('checkout.receipt.errorState.title')}</h3>
      <p slot="secondary-text" className="paragraph-20">
        {t('checkout.receipt.errorState.body')}
      </p>
      <MarketButton slot="actions" rank="primary" onClick={onClick}>
        {t('checkout.receipt.errorState.cta')}
      </MarketButton>
    </MarketEmptyState>
  );
};
